import { Controller } from "stimulus"

export default class extends Controller {
  connect() {

    document.addEventListener('turbolinks:render', function() {
      _takashi.init_form();
    });
  }
}
